// Inline-ссылка в дизайн-системе: primary-color + semibold. Source: stage-4-screens.md §4.
//
// Поддерживает (а) `to` для wouter-навигации, (б) `onClick` для action'ов, (в) `href`/external для legal-открытий.

import { Link } from 'wouter';
import type { AnchorHTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import { cn } from '@/lib/utils';

type LinkTextBaseProps = {
  children: ReactNode;
  className?: string;
};

type LinkTextProps =
  | (LinkTextBaseProps & { to: string; onClick?: never; href?: never; external?: never })
  | (LinkTextBaseProps & { onClick: MouseEventHandler<HTMLButtonElement>; to?: never; href?: never; external?: never })
  | (LinkTextBaseProps & {
      href: string;
      external?: boolean;
      to?: never;
      onClick?: never;
    } & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'>);

export function LinkText(props: LinkTextProps) {
  const base = 'text-primary-text font-semibold underline-offset-2 hover:underline';

  if ('to' in props && props.to) {
    return (
      <Link href={props.to} className={cn(base, props.className)}>
        {props.children}
      </Link>
    );
  }

  if ('onClick' in props && props.onClick) {
    return (
      <button type="button" onClick={props.onClick} className={cn(base, props.className)}>
        {props.children}
      </button>
    );
  }

  const { href, external, className, children, target, rel } = props as Extract<
    LinkTextProps,
    { href: string }
  >;
  return (
    <a
      href={href}
      target={target ?? (external ? '_blank' : undefined)}
      rel={rel ?? (external ? 'noopener noreferrer' : undefined)}
      className={cn(base, className)}
    >
      {children}
    </a>
  );
}
